export type TooltipPageType =
	| 'dashboard'
	| 'transactions'
	| 'analytics'
	| 'developer-integration'
	| 'developer-business'
	| 'developer-webhook-logs'
	| 'wallet'
	| 'addresses'
	| 'withdrawals'
	| 'settings'
	| 'profile-information'
	| 'crypto-settings'
	| 'security'
	| 'update-pin'
	| 'reset-pin'
	| 'mfa-factor-authentication'
	| 'change-password'
	| 'activity-log'
	| 'automatic-settlement'
	| 'team-management';

const DEVELOPERDESCRIPTION =
	'Configure and manage your API integration tools in one place. Set up webhook URLs, manage API keys and withdrawal addresses, view transaction fees and markup settings, and monitor webhook delivery logs to support secure, efficient, and reliable integrations';

const SETTINGSDESCRIPTION =
	'Manage your business account preferences and security settings in one place. Update account information, configure security options like passwords and transaction PINs, manage team access, and customize operational settings to keep your account secure and aligned with your business needs.';

export const pageDataMap: Record<TooltipPageType, { label: string; description: string; link: string }> = {
	'analytics': {
		label: 'Analytics',
		description:
			'Gain insights into your business performance through transaction and volume analytics across supported currencies. Track trends over time, apply filters and custom date ranges, and use visual reports to monitor activity, measure performance, and support better operational decisions.',
		link: '',
	},
	'dashboard': {
		label: 'Dashboard Overview',
		description:
			'Get a quick overview of your account activity, balances, and performance in one place. View your wallets across supported currencies, track transaction trends with analytics, and carry out key actions like funding, withdrawing, or converting funds.',
		link: '',
	},
	'transactions': {
		label: 'Transactions',
		description:
			'View and manage transactions processed through your API integration in one place. Track transaction statuses, monitor payouts, review detailed records, and use search, filters, analytics, and export tools to analyze activity and easily access transaction data when needed.',
		link: '',
	},
	'activity-log': {
		label: 'Activity Log',
		description: SETTINGSDESCRIPTION,
		link: '',
	},
	'addresses': {
		label: 'Wallet Addresses',
		description:
			'Manage wallet addresses created for your sub-accounts in one place. View and label addresses, access address details and QR codes, monitor transactions tied to each address, and use search, filters, and export tools to easily track and manage address activity. ',
		link: '',
	},
	'automatic-settlement': {
		label: 'Settings',
		description: SETTINGSDESCRIPTION,
		link: '',
	},
	'change-password': {
		label: 'Settings',
		description: SETTINGSDESCRIPTION,
		link: '',
	},
	'crypto-settings': {
		label: 'Settings',
		description: SETTINGSDESCRIPTION,
		link: '',
	},
	'developer-integration': {
		label: 'Developer',
		description: DEVELOPERDESCRIPTION,
		link: '',
	},
	'developer-business': {
		label: 'Developer',
		description: DEVELOPERDESCRIPTION,
		link: '',
	},
	'developer-webhook-logs': {
		label: 'Developer',
		description: DEVELOPERDESCRIPTION,
		link: '',
	},
	'mfa-factor-authentication': {
		label: 'Settings',
		description: SETTINGSDESCRIPTION,
		link: '',
	},
	'profile-information': {
		label: 'Settings',
		description: SETTINGSDESCRIPTION,
		link: '',
	},
	'reset-pin': {
		label: 'Settings',
		description: SETTINGSDESCRIPTION,
		link: '',
	},
	'security': {
		label: 'Settings',
		description: SETTINGSDESCRIPTION,
		link: '',
	},
	'settings': {
		label: 'Settings',
		description: SETTINGSDESCRIPTION,
		link: '',
	},
	'team-management': {
		label: 'Settings',
		description: SETTINGSDESCRIPTION,
		link: '',
	},
	'update-pin': {
		label: 'Settings',
		description: SETTINGSDESCRIPTION,
		link: '',
	},
	'wallet': {
		label: 'Wallet Management',
		description:
			'Manage your business funds across supported currencies, perform actions like funding, withdrawals, and conversions, and monitor wallet activity in one place. Use filters, search, and export tools to review and manage wallet history, track transaction statuses, and access records whenever needed.',
		link: '',
	},
	'withdrawals': {
		label: 'Withdrawals',
		description:
			'Monitor and manage withdrawal requests initiated through your API integration. Track API payout activity, review withdrawal statuses and records, and use search, filters, and export tools to reconcile and manage withdrawal activity efficiently.',
		link: '',
	},
};

export const tooltipLinkMap: Record<string, { pageType: TooltipPageType; link: string }> = {
	'/home': { pageType: 'dashboard', link: '' },
	'/wallet': { pageType: 'wallet', link: '' },
	'/addresses': { pageType: 'addresses', link: '' },
	'/transactions': { pageType: 'transactions', link: '' },
	'/withdrawals': { pageType: 'withdrawals', link: '' },
	'/analytics': { pageType: 'analytics', link: '' },
	'/developer/integrations': { pageType: 'developer-integration', link: '' },
	'/developer/business': { pageType: 'developer-business', link: '' },
	'/developer/webhook-logs': { pageType: 'developer-webhook-logs', link: '' },
	'/settings': { pageType: 'settings', link: '' },
	'/settings/profile-information': { pageType: 'profile-information', link: '' },
	'/settings/crypto-settings': { pageType: 'crypto-settings', link: '' },
	'/settings/security': { pageType: 'security', link: '' },
	'/settings/security/update-pin': { pageType: 'update-pin', link: '' },
	'/settings/security/reset-pin': { pageType: 'reset-pin', link: '' },
	'/settings/security/mfa-factor-authentication': { pageType: 'mfa-factor-authentication', link: '' },
	'/settings/security/change-password': { pageType: 'change-password', link: '' },
	'/settings/security/activity-log': { pageType: 'activity-log', link: '' },
	'/settings/automatic-settlement': { pageType: 'automatic-settlement', link: '' },
	'/settings/team-management': { pageType: 'team-management', link: '' },
};
